var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2268 12.0095H20.7433V18.339H24.5196C27.4384 18.339 29.0481 17.1642 29.0481 15.0641C29.0481 13.0962 27.6641 12.0095 25.2268 12.0095Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7433 20.8503V27.826H25.3922C28.4313 27.826 30.0411 26.607 30.0411 24.3161C30.0411 22.0251 28.3861 20.8503 25.1966 20.8503H20.7433Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.385 0C7.53203 0 5.42139 2.49805 5.51572 5.20703C5.60635 7.80928 5.48867 11.1802 4.64023 13.9287C3.78926 16.6857 2.35049 18.4284 0 18.6523V21.1914C2.35059 21.4153 3.78926 23.158 4.64023 25.915C5.48867 28.6636 5.60635 32.0345 5.51582 34.6368C5.42139 37.3457 7.53203 39.8438 10.385 39.8438H39.6187C42.4716 39.8438 44.5822 37.3457 44.4879 34.6368C44.3973 32.0345 44.5149 28.6636 45.3633 25.915C46.2144 23.158 47.6495 21.4153 50 21.1914V18.6523C47.6495 18.4284 46.2144 16.6857 45.3633 13.9287C44.5149 11.1802 44.3973 7.80928 44.4879 5.20703C44.5822 2.49805 42.4716 0 39.6187 0H10.385ZM33.4864 24.5217C33.4864 28.2519 30.7031 30.5134 26.0843 30.5134H17.3731V9.32197H26.0392C29.8907 9.32197 32.4183 11.4074 32.4183 14.6089C32.4183 16.8558 30.7182 18.8677 28.5517 19.2201V19.3376C31.5005 19.6607 33.4864 21.7021 33.4864 24.5217Z",
    fill: "#FEFEFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.dd41a2ad4a083895642f2985b899f0c5.svg";
export { ForwardRef as ReactComponent };